// Integrations that share at least one shared setting with the given one,
// de-duplicated by uuid and excluding the integration itself.
export default function linkedIntegrations(
  integrationId,
  allSharedSettings = [],
) {
  const byUuid = {};

  allSharedSettings
    .filter((setting) =>
      (setting.integrations || []).some((item) => item.uuid === integrationId),
    )
    .forEach((setting) => {
      (setting.integrations || [])
        .filter((item) => item.uuid !== integrationId)
        .forEach((item) => {
          byUuid[item.uuid] = item;
        });
    });

  return Object.values(byUuid);
}
